<!-- 导购员名单页面：用于管理导购员分类及导购员列表的增删改查操作 -->
<!-- 左侧面板：分类列表，支持新增、编辑、删除分类及切换选中分类 -->
<!-- 右侧面板：导购员数据表格，支持新增导购员、删除导购员及分页查询 -->
<!-- 新增导购员弹窗：选择用户作为导购员并关联至当前分类 -->
<!-- 新增/编辑分类弹窗：输入分类名称进行新增或编辑操作 -->
<!-- 导购员名单 -->
<template>
    <div class="container">
        <div class="lefter">
            <Button
                class="theme-bc mt12 mb24 ml12"
                icon="md-add-circle"
                type="warning"
                @click="goAddCategory"
                >新增分类</Button
            >
            <div class="card-container">
                <div
                    :class="category_value == index ? 'card-active' : 'card'"
                    v-for="(item, index) of typeList"
                    :key="item.id"
                    @click="goActiveCategory(index, item)"
                >
                    <div>{{ item.name }}</div>
                    <div v-if="item.id != -1" class="category-right">
                        <div>{{ item.guide_count }}</div>
                        <img
                            src="@/assets/diy_input.png"
                            class="help-add-icon"
                            @click.stop="goAddCategory(item)"
                        />
                        <img
                            src="@/assets/delete.png"
                            class="help-del-icon"
                            @click.stop="goDelCategory(item)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <Button
                class="theme-bc mb24"
                icon="md-add-circle"
                type="warning"
                @click="goAddModal"
                >新增导购员</Button
            >
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="name">
                    <div>{{ row.customer ? row.customer.name : "" }}</div>
                </template>
                <template slot-scope="{ row }" slot="phone">
                    <div>{{ row.customer ? row.customer.phone : "" }}</div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <Button type="error" ghost label="small" @click="goDel(row)"
                        >删除</Button
                    >
                </template>
            </Table>
            <div class="text-align-right mt24">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-total
                    @on-change="goChangePage"
                />
            </div>
        </div>

        <!-- 新增/编辑 -->
        <Modal
            v-model="addModal"
            title="新增导购员"
            width="500"
            :mask-closable="false"
        >
            <Form
                :model="formItem"
                label-position="right"
                :label-width="100"
                class="mt24"
            >
                <FormItem label="选择导购员：">
                    <Select
                        class="w300"
                        v-model="formItem.customer_id"
                        clearable
                        filterable
                        placeholder="请选择导购员"
                    >
                        <Option
                            v-for="item in customerList"
                            :value="item.id"
                            :key="item.id"
                            :label="`${item.name} ${item.phone}`"
                        />
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="goCancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="goSubmitModal"
                    >确认</Button
                >
            </div>
        </Modal>
        <!-- 新增分类/编辑分类 -->
        <Modal
            v-model="addCategoryModal"
            :title="addCategoryModalTitle"
            width="500"
            :mask-closable="false"
        >
            <Form
                :model="formCategoryItem"
                label-position="right"
                :label-width="100"
                class="mt24"
            >
                <FormItem label="分类名称：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formCategoryItem.name"
                        placeholder="请输入分类名称"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="goCancelCategoryModal">取消</Button>
                <Button
                    class="theme-bc"
                    type="warning"
                    @click="goSubmitCategoryModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    shopping_list,
    shopping_save,
    shopping_delete,
    shopping_type,
    shopping_type_save,
    shopping_type_delete,
    customer_select,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 30,
                type_id: -1,
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "用户名称", slot: "name", align: "center" },
                { title: "手机号", slot: "phone", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "100px",
                },
            ],
            dataTable: [],
            addModal: false,
            formItem: {
                type_id: -1,
                customer_id: "",
            },
            typeList: [{ id: -1, name: "全部" }],
            category_value: 0,
            addCategoryModal: false,
            addCategoryModalTitle: "",
            formCategoryItem: {
                id: "",
                name: "",
            },
            customerList: [],
        };
    },
    mounted() {
        this.getShoppingType();
        this.getProductSelect();
    },
    methods: {
        // 用户下拉列表
        getProductSelect() {
            customer_select()
                .then((res) => {
                    this.customerList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getShoppingType() {
            shopping_type()
                .then((res) => {
                    // 1. 获取接口返回列表
                    const list = res.data?.data || [];

                    // 2. 【关键】最前面插入一个「全部」选项
                    const allItem = {
                        id: -1, // 全部用 -1，和你原来逻辑一致
                        name: "全部", // 显示文字，可自己改
                    };
                    this.typeList = [allItem, ...list]; // 全部放在第一个

                    // 3. 默认选中第一个（也就是「全部」）
                    this.storePrams.type_id = this.typeList[0].id;
                    this.formItem.type_id = this.typeList[0].id;

                    this.getList();
                })
                .catch((err) => {
                    this.$Message.error(err.msg || "获取分类失败");

                    // 4. 失败时，也只显示「全部」
                    this.typeList = [{ id: -1, name: "全部" }];

                    // 同样默认选中
                    this.storePrams.type_id = -1;
                    this.formItem.type_id = -1;
                });
        },
        getList() {
            shopping_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data?.data || [];
                    this.total = res.data?.total || 0;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                    this.dataTable = [];
                    this.total = 0;
                });
        },
        goChangePage(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goAddModal() {
            this.formItem.customer_id = "";
            this.$nextTick(() => {
                this.addModal = true;
            });
        },
        // 确定
        goSubmitModal() {
            if (!this.formItem.customer_id) {
                this.$Message.warning("请选择导购员");
                return;
            }
            shopping_save(this.formItem)
                .then((res) => {
                    this.getList();
                    this.addModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goCancelModal() {
            this.addModal = false;
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    shopping_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        goActiveCategory(index, item) {
            this.category_value = index;
            if (item) {
                this.storePrams.type_id = item.id;
                this.formItem.type_id = item.id;
            }
            this.getList();
        },
        goAddCategory(item) {
            if (item.id) {
                this.addCategoryModalTitle = "编辑分类";
                this.formCategoryItem.id = item.id;
                this.formCategoryItem.name = item.name;
            } else {
                this.addCategoryModalTitle = "新增分类";
                this.formCategoryItem.id = "";
                this.formCategoryItem.name = "";
            }
            this.addCategoryModal = true;
        },
        // 确定
        goSubmitCategoryModal() {
            if (!this.formCategoryItem.name.trim()) {
                this.$Message.warning("请输入分类名称");
                return;
            }
            shopping_type_save(this.formCategoryItem)
                .then((res) => {
                    this.getShoppingType();
                    this.addCategoryModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goCancelCategoryModal() {
            this.addCategoryModal = false;
        },
        goDelCategory(item) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    shopping_type_delete({ id: item.id })
                        .then((res) => {
                            this.getShoppingType();
                            // 如果删除的是当前选中的分类，重置选中状态
                            if (this.storePrams.type_id === item.id) {
                                this.storePrams.type_id = -1;
                                this.formItem.type_id = -1;
                                this.category_value = 0;
                            }
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
    },
};
</script>

<style scoped>
.container {
    width: 100%;
    display: flex;
    flex-direction: row;
}
.lefter {
    padding: 12px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    width: 30%;
    border-right: 1px solid #eee;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    width: 70%;
}
.text-align-right {
    text-align: right;
}
.card-container {
    width: 100%;
}
.card-active {
    padding: 10px;
    background: #e8eaf4;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    cursor: pointer;
}
.card {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #666666;
    cursor: pointer;
}
.category-right {
    margin-left: 24px;
    display: flex;
    align-items: center;
}
.help-add-icon {
    margin-left: 24px;
    min-width: 14px;
    width: 14px;
    min-height: 14px;
    height: 14px;
}
.help-del-icon {
    margin: 0 2px 0 12px;
    min-width: 20px;
    width: 20px;
    min-height: 20px;
    height: 20px;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>